import React from 'react';
import { Flex, FlexProps } from 'rebass';

// for chaining form bits;
type ChildrenPlus = FlexProps & {
  children: React.ReactNode;
};

const FormComboGroup = (props: ChildrenPlus): JSX.Element => {
  return (
    <Flex
      {...(props as any)}
      sx={{
        ...props.sx,
        '> * + *': {
          marginLeft: '-1px !important',
        },
      }}
    >
      {props.children}
    </Flex>
  );
};

export { FormComboGroup };
